// +----------------------------------------------------------------------
// | Desc:导入全局配置
// +----------------------------------------------------------------------
import Vue from "vue"; //导入 Vue 框架
import config from "@/config/config.js"; //导入全局配置文件
Vue.prototype.$config = config; //定义全局配置信息
Vue.prototype.$configBase = function (url, isface) {
  return config;
};

// +----------------------------------------------------------------------
// | Desc:导入框架公共库
// +----------------------------------------------------------------------
import "@/layout/units/toast.js"; //导入提示库
import "@/layout/units/https.js"; //导入路径库(路径组合、接口请求、链接跳转等)
import "@/layout/units/valid.js"; //导入验证库
import "@/layout/units/format.js"; //导入格式化库(原数据处理与存储)
import "@/layout/units/date.js"; //导入日期库
import "@/layout/units/tool.js"; //综合工具
import "@/layout/units/wechat.js"; //微信JSSDK
import "@/layout/units/excel.js"; //excel库

// +----------------------------------------------------------------------
// | Desc:登录与路由库
// +----------------------------------------------------------------------
import "@/config/login.js"; //登录库

// +----------------------------------------------------------------------
// | Desc:导入项目私有库
// +----------------------------------------------------------------------
import "@/configOs/js/os.js"; //碎片库
import "@/configOs/js/copy.js"; //复制库
import "@/configOs/js/excel.js"; //excel库
import "@/configOs/js/haibao.js"; //海报库
